'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});
exports['default'] = AnimateConfig;

function AnimateConfig($animateProvider) {
    $animateProvider.classNameFilter(/^(?:(?!ng-animate-disabled).)*$/);
}

AnimateConfig.$inject = ['$animateProvider'];
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./resources/assets/js/src/config/animate.js
 ** module id = 10
 ** module chunks = 0
 **/